import { Descriptions, Tag } from "antd";
import trans from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";

export function MemberInfoTab({ data }) {
  const statusColors = {
    ACTIVE: `green`,
    INACTIVE: `red`,
  };

  if (!data) {
    return null;
  }

  const getRoleLabel = (role) => {
    const roleMap = {
      STANDARD_USER: trans("Standard User"),
      SUPERVISOR: trans("Supervisor"),
      PROJECT_MANAGER: trans("Project Manager"),
      SYSTEM_ADMINISTRATOR: trans("System Administrator"),
    };
    return roleMap[role] || role;
  };

  const items = [
    {
      label: trans("Name"),
      children: data?.name || "-",
      span: 3,
    },
    {
      label: trans("Email"),
      children: data?.email || "-",
      span: 3,
    },
    {
      label: trans("Phone Number"),
      children: data?.phone || "-",
      span: 3,
    },
    {
      label: trans("System Role"),
      children: data?.systemRole ? getRoleLabel(data.systemRole) : "-",
      span: 3,
    },
    {
      label: trans("Status"),
      span: 6,
      children: (
        <Tag
          color={data?.disabled ? "red" : "green"}
          className="text-capitalize"
        >
          {trans(data?.disabled ? "Deactivated" : "Active")}
        </Tag>
      ),
    },
    {
      label: trans("Last Login"),
      children: data?.lastLoginAt ? formatDateString(data.lastLoginAt) : "-",
      span: 3,
    },
    {
      label: trans("Login Count"),
      children: data?.loginCount ? data.loginCount : "0",
      span: 3,
    },
    {
      label: trans("Created At"),
      children: data?.inserted_at ? formatDateString(data.inserted_at) : "-",
      span: 3,
    },
    {
      label: trans("Teams Assigned Count"),
      children: data?.teamMemberships ? data.teamMemberships.length : "0",
      span: 3,
    }
  ];

  return (
    <div style={{ padding: "16px 0" }}>
      <Descriptions
        title={trans("Member Information")}
        bordered
        column={6}
        items={items}
        size="small"
      />
    </div>
  );
}
